module.exports = __webpack_public_path__ + "static/media/inktoberCandyCorn.461e8ef0.gif";